export const reduxKey = '@@compliantLocalStorage';
export var CompliantLocalStorageKeys = /*#__PURE__*/ function(CompliantLocalStorageKeys) {
    CompliantLocalStorageKeys["MURO"] = "muro";
    CompliantLocalStorageKeys["RECENT_COLORS"] = "custombox.recent.colors";
    CompliantLocalStorageKeys["INTENTS"] = "intents";
    CompliantLocalStorageKeys["INTENTS_OTHER"] = "intents_other";
    CompliantLocalStorageKeys["STATUS_SUBMIT_COUNTER"] = "statusUpdateSubmitCounter";
    CompliantLocalStorageKeys["CHATDB"] = "chatDB";
    CompliantLocalStorageKeys["EDITOR_DRAFTS"] = "editorDrafts";
    CompliantLocalStorageKeys["TIPTAP_DRAFTS"] = "tiptapDrafts";
    CompliantLocalStorageKeys["NC_DELETE_ON_REPLY"] = "ncDeleteOnReply";
    CompliantLocalStorageKeys["DO_NOT_SHOW_AGAIN"] = "confirm.modal.do.not.show";
    CompliantLocalStorageKeys["SOCIAL"] = "social";
    CompliantLocalStorageKeys["DREAMUP_ANON_FORM"] = "dreamup_anon_form";
    CompliantLocalStorageKeys["PWA_NOTIFICATIONS"] = "pwa_notifications";
    return CompliantLocalStorageKeys;
}({});
export var CompliantCategories = /*#__PURE__*/ function(CompliantCategories) {
    CompliantCategories["ESSENTIAL"] = "essential";
    CompliantCategories["FUNCTIONAL"] = "functional";
    return CompliantCategories;
}({});
export const LocalStorageCategoryTypeConfig = {
    ["intents"]: "essential",
    ["intents_other"]: "essential",
    ["chatDB"]: "essential",
    ["confirm.modal.do.not.show"]: "essential",
    ["social"]: "essential",
    ["muro"]: "functional",
    ["custombox.recent.colors"]: "functional",
    ["statusUpdateSubmitCounter"]: "functional",
    ["editorDrafts"]: "functional",
    ["ncDeleteOnReply"]: "functional",
    ["pwa_notifications"]: "essential"
};

//# sourceMappingURL=constants.js.map